import React from "react";
import moment from "moment";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const getVisibleApprovers = (approvers = []) => approvers.filter((approver) => {
  const role = approver && approver.role ? approver.role.toLowerCase().trim() : "";
  return role === "creator" || Boolean(approver && approver.signature && `${approver.signature}`.trim());
});

export default function EmergencyProcedureDocumentAuthorization({ procedure = {}, sections = {} }) {
  const authorization = sections.document_authorization && sections.document_authorization.data
    ? sections.document_authorization.data
    : {};
  const approvers = getVisibleApprovers(Array.isArray(authorization.approvers) ? authorization.approvers : []);
  const notes = procedure.emergency_procedures_authorisation_notes || "";

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.EmergencyProcedureSectionNum}`}>2</span>
        Document Authorization
      </div>
      <div className={styles.PreviewSectionBody}>
        {notes ? <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: notes }} /> : null}
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Action</th>
              <th>Date</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {approvers.length > 0 ? approvers.map((approver, index) => (
              <tr key={`${approver.name || "approver"}-${index}`}>
                <td><strong>{approver.name || ""}</strong></td>
                <td style={{ textTransform: "capitalize" }}>{approver.position || ""}</td>
                <td>{approver.phone_number || ""}</td>
                <td>{approver.action || ""}</td>
                <td>{approver.date ? moment.utc(approver.date).format("DD/MM/YYYY") : <span>&mdash;</span>}</td>
                <td>{approver.signature ? <img style={{ maxWidth: "auto", objectFit: "contain", maxHeight: "20px" }} src={approver.signature} alt="Signature" /> : <span>&mdash;</span>}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan={6} className={styles.PreviewTableEmpty}>No approvers available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
